// components/Admin/EmoticonManager/index.jsx

import React, { useState, useCallback, useEffect } from 'react';
import {
    Box, Tabs, Tab, Paper, Button, useMediaQuery, useTheme
} from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';

import EmoticonFormModal from './EmoticonFormModal';
import EmoticonTable from './EmoticonTable';
import EmoticonLogTable from './EmoticonLogTable';
import EmoticonStatsChart from './EmoticonStatsChart';
import api from '../../../api/axios';

const EmoticonManager = () => {
    const [emoticons, setEmoticons] = useState([]);
    const [tab, setTab] = useState(0);
    const [openForm, setOpenForm] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const fetchEmoticons = useCallback(() => {
        api.get('/api/management/emoticons/')
            .then(res => setEmoticons(res.data))
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        fetchEmoticons();
    }, [fetchEmoticons]);

    return (
        <Box sx={{ p: isMobile ? 2 : 4 }}>
            <Paper
                elevation={2}
                sx={{
                    mb: 3,
                    borderRadius: 2,
                    backgroundColor: '#f5f5f5',
                    px: 2,
                }}
            >
                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="fullWidth"
                >
                    <Tab icon={<VisibilityIcon />} iconPosition="start" label={isMobile ? '' : '등록 / 노출 관리'} />
                    <Tab icon={<ReceiptLongIcon />} iconPosition="start" label={isMobile ? '' : '구매 로그 보기'} />
                    <Tab icon={<InsertChartOutlinedIcon />} iconPosition="start" label={isMobile ? '' : '통계 보기'} />
                </Tabs>
            </Paper>

            {tab === 0 && (
                <>
                    <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} mb={2}>
                        <Button
                            variant="contained"
                            onClick={() => setOpenForm(true)}
                            fullWidth={isMobile}
                        >
                            + 이모티콘 등록
                        </Button>
                    </Box>

                    <EmoticonTable emoticons={emoticons} refresh={fetchEmoticons} />
                    <EmoticonFormModal
                        open={openForm}
                        onClose={() => setOpenForm(false)}
                        onSuccess={fetchEmoticons}
                    />
                </>
            )}

            {tab === 1 && <EmoticonLogTable />}
            {tab === 2 && <EmoticonStatsChart />}
        </Box>
    );
};

export default EmoticonManager;
